var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Zoom_in",
    "data-name": "Zoom in",
    d: "M15.935,14.563h-.723l-.256-.247a5.955,5.955,0,1,0-.64.64l.247.256v.723L19.137,20.5,20.5,19.137Zm-5.489,0a4.117,4.117,0,1,1,4.117-4.117A4.111,4.111,0,0,1,10.446,14.563ZM12.733,10.9H10.9v1.83H9.989V10.9H8.159V9.989h1.83V8.159H10.9v1.83h1.83Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/IconZoomIn.8c389f10.svg";
export { ForwardRef as ReactComponent };